import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 413,
  name: 'Payload Too Large',
  description:
    'The request body exceeds the server\'s maximum allowed size. The server refuses to process the request because the payload is larger than it is configured to accept.',
  causes: [
    'Uploading a file that exceeds the server\'s upload size limit (e.g., nginx default is 1MB via client_max_body_size).',
    'Sending a JSON or form body that is too large, often due to base64-encoded images or large data payloads embedded in the request.',
    'A reverse proxy or CDN (e.g., Cloudflare) has a lower body size limit than your application server.',
  ],
  fixes: [
    'Reduce the payload size. Compress files before uploading, or use multipart uploads for large files instead of sending them in a single request.',
    'Increase the server\'s body size limit: client_max_body_size in nginx, LimitRequestBody in Apache, or the equivalent in your application framework.',
    'Check all layers of your stack — the CDN, load balancer, reverse proxy, and application server each have their own size limits. The lowest one wins.',
  ],
  monitoringTip:
    'If your upload endpoint suddenly returns 413 for files that previously worked, a configuration change likely lowered the size limit. Uptrack catches this by monitoring the endpoint\'s response codes.',
}

export const Route = createFileRoute('/_site/http/413')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
